module.exports = __webpack_public_path__ + "static/media/mode-2004.9f74fb76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2004.svg
// module id = 1028
// module chunks = 2